









import { Component, Prop, Vue } from "vue-property-decorator";
import { IClient } from "@/models/clients";

@Component
export default class SupportPinReveal extends Vue {
  // Props

  @Prop({ default: "" })
  public readonly supportPin!: IClient["support_pin"];

  // Data

  public isMasked = true;

  // Computed

  public get visiblePin() {
    return this.isMasked ? "•".repeat(6) : this.supportPin;
  }

  public get action() {
    if (this.isMasked) return this.$t("_action.show_pin");
    return this.$t("_action.copy_and_hide");
  }

  // Methods

  public togglePin($event) {
    $event.stopPropagation();
    if (!this.isMasked)
      this.$store.dispatch("ui/copyToClipboard", this.supportPin);
    this.isMasked = !this.isMasked;
  }
}
